import useActiveOrDefaultChain from 'src/common/hooks/web3/useActiveOrDefaultChain'
import { useCallback } from 'react'
import { Abi } from 'thirdweb/utils'
import { _getThirdwebContract } from '../utils'

const useGetContract = () => {
  const chain = useActiveOrDefaultChain()

  const getContract = useCallback(
    (address: string, contractAbi?: Abi) => {
      return _getThirdwebContract(address, chain, contractAbi)
    },
    [chain]
  )

  return {
    getContract,
  }
}

export default useGetContract
